<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("relatorio-lancamentos-detalhe") }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("despesas")
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: 'des-relatorio-lancamentos-list',
                                            })
                                        "
                                        >{{
                                            $t("relatorio-lancamentos")
                                        }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $t("relatorio-lancamentos-detalhe")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({
                                    name: 'des-relatorio-lancamentos-list',
                                })
                            "
                        >
                            {{ $t("voltar") }}
                        </button>
                    </div>
                </div>
                <br />

                <div class="box" v-if="data != null">
                    <div class="card-title-custom mb-2">
                        <p class="is-size-4">
                            {{ $t("motivo-despesa") }}:
                            {{ data.descricaomotivo }}
                            <i
                                :class="data.despesamotivo.icone.toLowerCase()"
                            ></i>
                        </p>
                    </div>
                    <hr />

                    <div class="columns is-flex-wrap">
                        <div class="column is-4">
                            {{ $t("origem") }}: <br />
                            {{ data.origem }}
                        </div>
                        <div class="column is-4">
                            {{ $t("valor") }}: <br />
                            {{ getDecimal(data.valor , null, true) }}
                        </div>
                        <div class="column is-4">
                            {{ $t("data") }}: <br />
                            {{ data.datahora | moment("L") }}
                        </div>

                        <div class="column is-4">
                            {{ $t("empresa") }}: <br />
                            {{ data.empresa.nome }}
                        </div>
                        <div class="column is-4">
                            {{ $t("colaborador") }}: <br />
                            {{ data.usuario.nome }}
                        </div>
                        <div class="column is-4" v-if="data.qntFotos > 0">
                            {{ $t("fotos") }}: <br />
                            <div
                                @click="
                                    findAndPushFotosDespesa(
                                        data.iddespesa
                                    )
                                "
                                class="cursor-pointer"
                                v-tippy 
                                :title="$t('msg-tooltip-despesa-n-fotos', { n: data.qntFotos })"
                            >
                                <b-icon
                                    class="has-badge-primary mt-1"
                                    icon="camera"
                                    :data-badge="data.qntFotos"
                                />
                            </div>
                        </div>

                        <div
                            class="column is-4"
                            v-if="
                                data.odometro != 0 &&
                                data.odometro != -1 &&
                                data.odometro != null
                            "
                        >
                            {{ $t("odometro") }}: <br />
                            {{ data.odometro }}
                        </div>
                        <div
                            class="column is-4"
                            v-if="
                                data.kmpercorrido != 0 &&
                                data.kmpercorrido != -1 &&
                                data.kmpercorrido != null
                            "
                        >
                            {{ $t("kmpercorrido") }}: <br />
                            {{ data.kmpercorrido }}
                        </div>
                        <div
                            class="column is-4"
                            v-if="data.placa != '' && data.placa != null"
                        >
                            {{ $t("placa-veiculo") }}: <br />
                            {{ data.placa }}
                        </div>
                        <div
                            class="column is-4"
                            v-if="
                                data.centrodecusto != '' &&
                                data.centrodecusto != null
                            "
                        >
                            {{ $t("centrocusto") }}: <br />
                            {{ data.centrodecusto }}
                        </div>
                        <div
                            class="column is-4"
                            v-if="
                                data.estabelecimento != '' &&
                                data.estabelecimento != null
                            "
                        >
                            {{ $t("estabelecimento") }}: <br />
                            {{ data.estabelecimento }}
                        </div>
                        <div
                            class="column is-12"
                            v-if="data.obs != '' && data.obs != null"
                        >
                            {{ $t("observacao") }}: <br />
                            {{ data.obs }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal fotos da despesa -->
        <b-modal
            class="modal-default"
            :active.sync="isShowModalFotos"
            style="z-index: 1000"
            @close="closeModalFotos"
        >
            <div class="modal-card-body">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <template>
                            <b-carousel
                                :pause-info="false"
                                :animated="'fade'"
                                :progress="true"
                            >
                                <b-carousel-item
                                    v-for="(carousel, i) in carousels"
                                    :key="i"
                                >
                                    <section
                                        :class="`hero is-medium is-${carousel.color}`"
                                    >
                                        <div
                                            class="hero-body-img has-text-centered"
                                        >
                                            <b-image
                                                :src="carousel.url"
                                                :responsive="true"
                                                class="image-control"
                                            />
                                        </div>
                                    </section>
                                </b-carousel-item>
                            </b-carousel>
                        </template>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import RelatorioLancamentosService from "@/services/despesas/RelatorioLancamentosService";
import DespesaService from "@/services/despesas/DespesaService";

export default {
    data() {
        return {
            data: null,
            service: new RelatorioLancamentosService(this.$http, this.$router),
            isLoading: false,
            permissao: {},
            isShowModalFotos: false,
            carousels: [],
            fotosDespesa: [],
            despesaService: new DespesaService(this.$http, this.$router),
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            "despesas",
            "relatorios",
            "des-relatorio-lancamentos"
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "relatorios" },
            });
        } else {
            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
            } else {
                this.$router.push({ name: "des-relatorio-lancamentos" });
            }
        }
    },
    methods: {
        findAndPushFotosDespesa(iddespesa) {
            this.despesaService
                .findAllFotosDespesasByIdDespesa(iddespesa)
                .then((r) => {
                    this.fotosDespesa = r.content;
                    this.fotosDespesa.forEach((foto) => {
                        this.carousels.push({
                            url: foto.caminho,
                            nome: foto.nome,
                        });
                    });
                })
                .catch((e) => {
                    console.error("Erro ao carregar os fotos: " + e);
                })
                .finally((_) => {
                    if (this.fotosDespesa.length > 0) {
                        this.isShowModalFotos = true;
                    }
                });
        },
        closeModalFotos() {
            this.carousels = [];
            this.isShowModalFotos = false;
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((res) => {
                    this.data = res.content;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;
    }
    .card-title-custom {
        text-align: center;
    }
    .b-table .table {
        border-collapse: collapse;
    }
    .hero-body-img {
        padding: 20px;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    @media screen and (max-width: 768px) {
        .b-table .table {
            border-collapse: separate;
        }
        .colums-mobile {
            width: 100% !important;
        }
        .b-table
            .table-wrapper.has-mobile-cards
            tr:not(.detail):not(.is-empty):not(.table-footer)
            td {
            justify-content: left;
            text-align: left;
        }
        .b-table .table-wrapper.has-mobile-cards .table-footer {
            margin-top: 15px;
            padding-left: 5px;
        }
    }
}
</style>
